import React, { useState } from "react";
import { Carousel, Card, Container } from "react-bootstrap";
import "./Login.css";
import Img1 from "../../assets/images/login/Img1.png";
import Img2 from "../../assets/images/login/Img2.png";
import Img3 from "../../assets/images/login/Img3.png";
import Img4 from "../../assets/images/login/Img4.png";
import Img5 from "../../assets/images/login/Img5.png";
import logo from "../../assets/images/login/Nathicharami Logo.png";
import cornerImg from "../../assets/images/login/corner.png";
import { BsFillTelephoneFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";
import Preloader from "../../Components/Loader/Loader";

const LoginSchema = object({
  phoneNumber: string()
    .matches(/^\d{10}$/, "Phone Number must be 10 digits")
    .required("Phone number is Required"),
});

export function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: LoginSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const formattedValues = {
          ...values,
          phoneNumber: Number(values.phoneNumber),
        };

        const { data } = await axiosInstance.post("login", formattedValues);

        if (data.status === true) {
          toast.success(data.message || "Login Successfully!");
          resetForm();
          localStorage.setItem("phoneNumber", values.phoneNumber);
          setTimeout(() => {
            navigate("/otp");
            setLoading(false);
          }, 3000);
        } else {
          toast.error("Something went wrong, please try again!");
          setLoading(false);
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
        setLoading(false);
      }
    },
  });
  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />
      <div className="loginContainer">
        <div className="loginLeft">
          <Carousel className="carousel">
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img1} />
                  </div>
                  <div className="carousel-title">Create Perfect Matches</div>
                  <div className="carousel-desc">
                    Join Nathicharami’s trusted network of matchmaking
                    professionals.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img2} />
                  </div>
                  <div className="carousel-title">Capture Love Stories</div>
                  <div className="carousel-desc">
                    Connect with couples seeking timeless wedding memories.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img3} />
                  </div>
                  <div className="carousel-title">Enhance Bridal Radiance</div>
                  <div className="carousel-desc">
                    List your services and get booked by brides and grooms.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img4} />
                  </div>
                  <div className="carousel-title">Spread the Love</div>
                  <div className="carousel-desc">
                    Promote Nathicharami and earn rewards for every successful
                    match.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img5} />
                  </div>
                  <div className="carousel-title">
                    Host Unforgettable Weddings
                  </div>
                  <div className="carousel-desc">
                    Showcase your venue to couples dreaming of their perfect
                    wedding.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
          </Carousel>
        </div>
        <div className="login-right">
          <form onSubmit={formik.handleSubmit}>
            <div className="loginLogo">
              <img src={logo} />
            </div>
            <div className="loginRight-text">Login</div>
            <div className="loginInput">
              <span
                style={{
                  color: "#9D9496",
                  marginRight: "5px",
                  fontSize: "16px",
                }}
              >
                <BsFillTelephoneFill />
              </span>
              <input
                type="text"
                placeholder="Enter Mobile Number"
                name="phoneNumber"
                onChange={(e) => {
                  const trimmedValue = e.target.value.replace(/\s+/g, "");
                  formik.setFieldValue("phoneNumber", trimmedValue);
                }}
                value={formik.values.phoneNumber}
              />
            </div>
            {formik.touched.phoneNumber && formik.errors.phoneNumber && (
              <div className="text-danger ">{formik.errors.phoneNumber}</div>
            )}
            <div>
              <div className="btnSend">
                <button type="submit">Send OTP</button>
              </div>
            </div>
          </form>
        </div>
        <div className="cornerImg">
          <img src={cornerImg} />
        </div>
      </div>
    </>
  );
}
